export const SAVE_SYSLOG =
  'ipfabric/Settings/ConfigurationManagement/SAVE_SYSLOG';
